import ExtraList from "./ExtraList";

export default ExtraList;
export { ExtraList };
